module.exports = __webpack_public_path__ + "static/zlecenie_windykacji-242d01eced6b118fc256bc4f99d1e6fc.pdf";